export const formatMessageContent = (input) => {
  return input
    .replace(/\s*,\s*/g, ', ')
    .replace(/(,\s*){2,}/g, ', ')
    .replace(/,\s*$/, '');
};
